import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { collection, addDoc } from "firebase/firestore";
import { db } from './firebase'; // firebase.js 경로에 맞게 수정하세요.

function ConsultationForm() {
  // 화면 너비 감지 (모바일/PC 구분)
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const location = useLocation(); // ✅ 최상위에서 호출

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = windowWidth <= 768; // 768px 이하를 모바일로 간주

  // PC 환경에서 사용하는 상태들
  const [field, setField] = useState('신규');
  const [name, setName] = useState('');
  const [contact, setContact] = useState('');
  const [content, setContent] = useState('');
  const [agreeAll, setAgreeAll] = useState(false);
  const [agreePersonal, setAgreePersonal] = useState(false);
  const [agreeMarketing, setAgreeMarketing] = useState(false);
  const formRef = useRef(null);

  // 전체동의 체크 시 나머지 체크박스 모두 선택
  useEffect(() => {
    if (agreeAll) {
      setAgreePersonal(true);
      setAgreeMarketing(true);
    }
  }, [agreeAll]);

  // 개별 체크박스 중 하나라도 해제되면 전체동의 해제
  useEffect(() => {
    if (!agreePersonal || !agreeMarketing) {
      setAgreeAll(false);
    }
  }, [agreePersonal, agreeMarketing]);

  // 스크롤 시 푸터가 보이면 폼 숨기기
  useEffect(() => {
    const handleScroll = () => {
      const footer = document.querySelector('.footer');
      const form = formRef.current;

      if (!footer || !form) return;

      const footerRect = footer.getBoundingClientRect();
      const offset =50;

      if (location.pathname === '/contact'){
        // 푸터가 보이므로 폼 숨김
        form.style.display = 'none';
        return;
      } else {
        // 푸터가 보이지 않으면 폼 표시
        form.style.display = 'block';
      }

      // footerRect.top < window.innerHeight 이면 푸터가 화면에 보이기 시작
      if (footerRect.top < window.innerHeight+offset) {
        // 푸터가 보이므로 폼 숨김
        form.style.display = 'none';
      } else {
        // 푸터가 보이지 않으면 폼 표시
        form.style.display = 'block';
      }
    };

    window.addEventListener('scroll', handleScroll);
    // 초기 실행
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, [location.pathname]);
  const isFormValid =
  name.trim() !== '' &&
  contact.trim() !== '' &&
  content.trim() !== '' &&
  agreePersonal;
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isFormValid) return;

    // 폼 데이터 구성
    const formData = {
      name,
      contact,
      content,
      agreePersonal,
      agreeMarketing,
      createdAt: new Date(),
    };

    try {
      // "consultations" 컬렉션에 데이터 저장
      const docRef = await addDoc(collection(db, "CounselSimple"), formData);
      console.log("Document written with ID: ", docRef.id);
      alert('상담신청이 완료되었습니다!');
    } catch (error) {
      console.error("Error adding document: ", error);
      alert("상담 신청에 실패했습니다. 다시 시도해주세요.");
    }

    // 폼 리셋
    setName('');
    setContact('');
    setAgreePersonal(false);
    setAgreeMarketing(false);
    setAgreeAll(false);
  };

  // 모바일에서는 폼 대신 버튼만 표시
  if (isMobile) {
    return (
      <div

        ref={formRef}
        style={{
          position: 'fixed',
          width:'100%',
          //left: 0,               // 화면 왼쪽 0
          //right: 0,              // 화면 오른쪽 0
          bottom: '0px',         // 화면 하단
          display: 'flex',
          textAlign: 'center', // 자식 인라인 요소를 수평 중앙 정렬
          alignItems: 'center',
          backgroundColor: '#ece9e1',
          borderTop: '1px solid #ccc',
          padding: '15px 20px',
          boxSizing: 'border-box',
          zIndex: 9999,            // 필요 시 우선순위 높이기
           flexDirection: 'column',   // 세로로 쌓기
        }}
      >
          <div style={{
        marginBottom: '8px',
        fontSize: '32px',
        fontWeight: 'bold',
        color: '#333'
      }}>
        ☎  1577-8788
      </div>
        <a
          href="/contact"
          style={{
            display: 'inline-block',
            padding: '12px 20px',
            backgroundColor: '#D4AF37',
            color: '#fff',
            borderRadius: '5px',
            textDecoration: 'none'
          }}
        >
          상담페이지로 이동
        </a>
      </div>
    );
  }

  // PC 환경: 폼 표시
  return (
    <form
      className="consultation-form"
      ref={formRef}
      onSubmit={handleSubmit}
      style={{
        position: 'fixed',  // 예: 화면 하단 고정
        bottom: '0px',
        right: '20px',
        display: 'flex',
        flexDirection: 'column',
        // 필요한 스타일 추가
      }}
    >
        {/* 상단에 전화번호 */}
  <div style={{
    textAlign: 'center',
    marginBottom: '12px',
    fontSize: '50px',
    fontWeight: 'bold'
  }}>
    ☎  1577-8788
  </div>
        {/* ① 폼 상단에 전화번호 표시 */}
      
      <div className="consultation-layout">
        {/* 왼쪽 컬럼: 분류 */}
        <div className="left-col">
          <span className="classification-label">분류</span>
          <div className="radio-group">
            <label>
              <input
                type="radio"
                name="field"
                value="신규"
                checked={field === '신규'}
                onChange={(e) => setField(e.target.value)}
              />
              신규
            </label>
            <label>
              <input
                type="radio"
                name="field"
                value="분양"
                checked={field === '분양'}
                onChange={(e) => setField(e.target.value)}
              />
              분양
            </label>
            <label>
              <input
                type="radio"
                name="field"
                value="이장"
                checked={field === '이장'}
                onChange={(e) => setField(e.target.value)}
              />
              이장
            </label>
          </div>
        </div>

        {/* 세로 구분선 */}
        <div className="vertical-divider"></div>

        {/* 중간 컬럼: 이름/연락처 */}
        <div className="mid-col">
          <div className="input-line">
            <label htmlFor="name"><strong>이름</strong></label>
            <input
              type="text"
              id="name"
              placeholder="이름 입력"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>
          <div className="input-line">
            <label htmlFor="contact"><strong>연락처</strong></label>
            <input
              type="tel"
              id="contact"
              placeholder="연락처 입력"
              value={contact}
              onChange={(e) => setContact(e.target.value)}
              required
            />
          </div>
        </div>

        {/* 세로 구분선 */}
        <div className="vertical-divider"></div>

        {/* 오른쪽 컬럼: 상담내용, 체크박스, 버튼 */}
        <div className="right-col">
          <div className="content-row">
            <div className="content-line">
              <label htmlFor="content"><strong>상담내용</strong></label>
              <input
                type="text"
                id="content"
                placeholder="상담내용 입력"
                value={content}
                onChange={(e) => setContent(e.target.value)}
                required
              />
            </div>
            <button type="submit" className="submit-button">상담 신청</button>
          </div>

          <div className="consent-container">
            <div className="consent-item">
              <input
                type="checkbox"
                id="agreeAll"
                checked={agreeAll}
                onChange={(e) => setAgreeAll(e.target.checked)}
              />
              <label htmlFor="agreeAll"><strong>전체동의</strong></label>
            </div>
            <div className="consent-item">
              <input
                type="checkbox"
                id="agreePersonal"
                checked={agreePersonal}
                onChange={(e) => setAgreePersonal(e.target.checked)}
              />
              <label htmlFor="agreePersonal">개인정보 수집 및 이용 (필수)</label>
            </div>
            <div className="consent-item">
              <input
                type="checkbox"
                id="agreeMarketing"
                checked={agreeMarketing}
                onChange={(e) => setAgreeMarketing(e.target.checked)}
              />
              <label htmlFor="agreeMarketing">마케팅 활용 (선택)</label>
            </div>
            <div className="terms-link">
              <a href="/terms" target="_blank" rel="noopener noreferrer">
                약관보기
              </a>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
}

export default ConsultationForm;